export default "__VITE_ASSET__197d432d__"